import type { Metadata } from '@xing-com/crate-core-assets';

import { useRuntime } from '../internal';

export function useMetadata(name: string): Metadata {
  return useRuntime().metadataMap[name];
}
